import { getUrlGameId } from '@op/utils/url';

/**
 * 获取 AI_TAG_COLOR 的 storage key，包含游戏 id
 * @returns AI_TAG_COLOR-{gameid}
 */
export function getAITagColorKey() {
  const gameId = getUrlGameId();
  return gameId ? `AI_TAG_COLOR-${gameId}` : 'AI_TAG_COLOR';
}
